import React from 'react';
import { Skeleton } from '../skeleton/Skeleton';

export const EventCardsSkeleton = () => {
	return (
		<>
			{[0, 1].map((i) => (
				<div key={i} className="w-full max-w-[400px] sm:min-w-[min(370px,90vw)]">
					<Skeleton height="240px" width="100%" style={{ borderRadius: '12px' }} />
				</div>
			))}
		</>
	);
};
